import React, { Component } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import PropTypes from "prop-types";

import {
  AppHeaderDropdown,
  AppNavbarBrand,
  AppSidebarToggler,
  AppAsideToggler
} from "@coreui/react";
// import logo from '../../assets/img/brand/logo.svg'
import logo from "../../assets/img/brand/logo2.png";
import sygnet from "../../assets/img/brand/logo.png";
import auth from "../../api/auth/Auth.jsx";
const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};

const INITIALS_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 25,
  height: 25,
  margin: "0 10px",
  borderRadius: "50%",
  background: "#20a8d8",
  color: "#fff",
  fontSize: "0.65rem",
  lineHeight: 1,
  fontWeight: 600
};

/** "sriram.puvvada@outcomex.com.au" -> "SP" */
function initials(email) {
  const parts = String(email || "").split("@")[0].split(/[._\s-]+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts.slice(0, 2).map(function(part) { return part.charAt(0).toUpperCase(); }).join("");
}

class DefaultHeader extends Component {
  state = { imageFailed: false };

  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    //   console.info ("development")
    // }

    let userName = "";
    try {
      userName = auth.accessToken.decoded.sub;
    } catch (e) {
      console.error(e);
    }
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          style={{ width: "auto", paddingLeft: "1rem", paddingRight: "0.5rem" }}
          full={{ src: logo, width: 160, height: 25, alt: "Outcome Logo" }}
          minimized={{
            src: sygnet,
            width: 30,
            height: 30,
            alt: "Outcome Logo"
          }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">
              <div className="main-navlink">
                Outcomex Operations and Sales Portal. Classification: Outcomex Internal
              </div>
            </NavLink>
          </NavItem>
          {/* <NavItem className="px-3">
            <NavLink href="#/users">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#">Settings</NavLink>
          </NavItem> */}
        </Nav>
        <Nav className="ml-auto" navbar>
          {/* <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem> */}
          <NavItem>
            <NavLink href="#/my" className="header-my-hub" title="My Hub — your requests, balances and approvals">
              <i className="pe-7s-home" />
              <span className="d-none d-sm-inline">My Hub</span>
            </NavLink>
          </NavItem>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              {auth.profileImgUrl && !this.state.imageFailed ? (
                <img
                  src={auth.profileImgUrl}
                  alt="Account"
                  className="img-avatar"
                  onError={() => this.setState({ imageFailed: true })}
                />
              ) : (
                <span className="img-avatar" style={INITIALS_STYLE} title={userName} aria-label="Account">
                  {initials(userName)}
                </span>
              )}
            </DropdownToggle>
            <DropdownMenu right style={{ right: "auto" }}>
              <DropdownItem header tag="div" className="text-center">
                <strong>Account</strong>
              </DropdownItem>
              <DropdownItem>
                <i className="fa fa-user" /> {userName}
              </DropdownItem>
              {/* <DropdownItem>
                <i className="fa fa-user" /> Updates<Badge color="info">42</Badge>
              </DropdownItem>
              <DropdownItem>
                <i className="fa fa-envelope-o" /> Messages<Badge color="success">42</Badge>
              </DropdownItem>
              <DropdownItem>
                <i className="fa fa-tasks" /> Tasks<Badge color="danger">42</Badge>
              </DropdownItem>
              <DropdownItem>
                <i className="fa fa-comments" /> Comments<Badge color="warning">42</Badge>
              </DropdownItem> */}
              <DropdownItem header tag="div" className="text-center">
                <strong>Settings</strong>
              </DropdownItem>

              {/* <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
              <DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
              <DropdownItem divider />
              <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem> */}
              <DropdownItem
                onClick={() => {
                  auth.logout();
                }}
              >
                <i className="fa fa-lock" /> Logout
              </DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        <AppAsideToggler className="d-md-down-none" />
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
